module.exports = __webpack_public_path__ + "img/button-a-misc-03-management.cbbf652a.png";